import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forma-pago-list',
  templateUrl: './forma-pago-list.component.html',
  styleUrls: ['./forma-pago-list.component.css'],
})
export class FormaPagoListComponent implements OnInit {
	public title: String;
	public dataGrid: any;
  
  constructor() { 
		this.title = "Forma Pagos";
		
		this.dataGrid = {
			keyGrid: "forma-pago",
			perPage: 10,
			endPoint: "/formas/pago",
			routeEdit: "/cobro/forma-pago-edit",
			columsDef: [
				{
					Header: "Nombre",
					Field: "nombre",
					Searchable: true
				}
			]
		};
  }

  ngOnInit() {
    //
  }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/forma-pago-list/forma-pago-list.component.ts